module.exports = __webpack_public_path__ + "img/logo_zuerich_tourismus_180x60.20c1cd99.png";